import { Link } from "react-router-dom";
export default function Section_3() {
    return <>
        <section className="w-full h-[70vh] background-image-section-3">
            <div className="w-full h-full flex flex-col items-center justify-center gap-5 lg:gap-9 text-white bg-black-blur">
                <h1 className="text-gray-300 text-lg">AMENITIES</h1>
                <h1 className="w-full sm:w-5/6 lg:w-[45%] text-center text-3xl lg:text-5xl">The Best Summer Vacation Tours For Your Family</h1>
                <Link to="/Search" className="px-8 py-3 bg-black hover:bg-white hover:text-black">Book Now</Link>
            </div>
        </section>
    </>
}
